import React, { useEffect, useState } from "react";
import KuikaNumber from "../../ui-kit/kuika-number/kuika-number";
import "./board-nav-badge.scss";
import {
  connectNotificationStream,
  refreshNotifications,
  subscribeNotifications,
  unreadNotificationCount
} from "./notifications";

/** An unread count as the badges show it: past nine it stays "9+", so a busy inbox does not widen them. */
export const formatUnreadCount = (count: number): string => (count > 9 ? "9+" : String(count));

// Renders a small unread-count badge for the board nav icon, mirroring the
// Helpdesk button's badge. Reads the backend-backed notification store: fetches
// once on mount and re-renders whenever the store changes (fetch / mark-read).
const BoardNavBadge: React.FC = () => {
  const [count, setCount] = useState<number>(() => unreadNotificationCount());

  useEffect(() => {
    const unsubscribe: () => void = subscribeNotifications(() => setCount(unreadNotificationCount()));
    void refreshNotifications();
    connectNotificationStream();
    return unsubscribe;
  }, []);

  if (count <= 0) return null;

  // A new notification rolls the count up in place; past nine the "9+" holds still.
  return (
    <div className="kuika-board-nav-badge">
      <KuikaNumber value={count} format={formatUnreadCount} />
    </div>
  );
};

export default BoardNavBadge;
